import { IconButton, List, ListItemText, TextField } from "@mui/material";
import { UListItemButton } from "../common/ui.buttons";
import { useSearch } from "../common/search";
import { USkeletonList } from "../common/ui.skeletons";

export function SearchResults(props) {
    const Component = props.component || BasicSearchResult;

    const search = useSearch()

    if (search.loading) {
        return <USkeletonList count={6} height={40} />
    }


    return <List>
        {search.result.map((r, idx) => <Component
            key={r.id || 'r-' + idx} value={r}
            selected={search.selected && search.selected.id === r.id}
            onClick={() => search.setSelected(r)}
        />)}
        {props.children}
    </List>
}

function BasicSearchResult(props) {
    const { value } = props;

    return <UListItemButton  {...props}>
        <ListItemText primary={value.name} />
    </UListItemButton>

}